module.exports = __webpack_public_path__ + "static/img/dy1-2.3f640ae.png";


//////////////////
// WEBPACK FOOTER
// ./static/workoff/excelimg/sougou/dy1-2.png
// module id = 937
// module chunks = 0